module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[90]89.08a3265.woff2";